/**
 * Transient UI state for the "compare chronology versions" flow: the two
 * versions picked in the compare modal's "Base version" and "Compare version"
 * fields, and whether that modal is open. These are the user's raw picks, not
 * yet chronologically ordered — `VersionsCompare.tsx` resolves which one is
 * actually older/newer for display. Kept as its own store (rather than living
 * on `MedicalChronologyContext`) so consumers only subscribe to this slice
 * instead of the whole medical chronology context value.
 */
import { create } from "zustand";

interface ChronologyCompareVersionsState {
  isComparePickerOpen: boolean;
  selectedBaseVersionId: string | null;
  selectedCompareVersionId: string | null;
  openComparePicker: () => void;
  closeComparePicker: () => void;
  startCompare: (baseVersionId: string, compareVersionId: string) => void;
  exitCompareMode: () => void;
  reset: () => void;
}

export const useChronologyCompareVersionsStore = create<ChronologyCompareVersionsState>((set) => ({
  isComparePickerOpen: false,
  selectedBaseVersionId: null,
  selectedCompareVersionId: null,
  openComparePicker: () => set({ isComparePickerOpen: true }),
  closeComparePicker: () => set({ isComparePickerOpen: false }),
  startCompare: (baseVersionId, compareVersionId) =>
    set({
      selectedBaseVersionId: baseVersionId,
      selectedCompareVersionId: compareVersionId,
      isComparePickerOpen: false,
    }),
  exitCompareMode: () => set({ selectedBaseVersionId: null, selectedCompareVersionId: null }),
  reset: () =>
    set({
      selectedBaseVersionId: null,
      selectedCompareVersionId: null,
      isComparePickerOpen: false,
    }),
}));
